var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-flex",
    { staticClass: "filter-balance" },
    _vm._l(_vm.filters, function ({ label, value, active }, index) {
      return _c(
        "v-btn",
        {
          key: index,
          staticClass: "btn-filter",
          class: active ? "white--text" : "",
          attrs: { color: active ? "primary" : "" },
          on: {
            click: function ($event) {
              return _vm.emitDateByFilter(value)
            },
          },
        },
        [_vm._v("\n    " + _vm._s(label) + "\n  ")]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }